import { Icon, Stack } from '@fluentui/react';
import React, { useMemo } from 'react';
import userGreyIcon from '../../../assets/icons/svg/userGrey.svg';
import logoSmIcon from '../../../assets/logoSm.svg';

const Avatar = (props) => {

    const {
        estEiffage = false,
    } = props;

    const icon = useMemo(
        () => estEiffage ? logoSmIcon : userGreyIcon,
        [estEiffage]
    );

    const styles = useMemo(
        () => {
            let styles = {
                outer: {
                    root: {
                        alignItems: "center",
                        border: "1px solid #8A8A8A",
                        borderRadius: 20,
                        height: 40,
                        justifyContent: "center",
                        width: 40
                    }
                },
            };

            return styles;
        },
        []
    );

    return <Stack styles={styles.outer}>
        <Icon imageProps={{ src: icon }} />
    </Stack>;

};

export default Avatar;